import { useRef } from 'react';

interface UseSkipOnboardingAnalysisAnimationOptions {
  /** When provided, defers the check until loading finishes (e.g. saved favorites). */
  isLoading?: boolean;
}

/**
 * Returns whether selections were already present when the step became ready,
 * so the analyzing progress animation can be skipped on reopen.
 */
export function useSkipOnboardingAnalysisAnimation(
  selected: readonly unknown[],
  { isLoading = false }: UseSkipOnboardingAnalysisAnimationOptions = {},
): boolean {
  const skipRef = useRef(false);
  const resolvedInitialRef = useRef(false);

  if (!isLoading && !resolvedInitialRef.current) {
    resolvedInitialRef.current = true;
    skipRef.current = selected.length > 0;
  }

  return skipRef.current;
}
